import { injectReducer } from "../../store/reducers";

export default store => ({
  // path: "/products",
  path: "/products(/category/:category/brand/:brand/model/:model)",
  /*  Async getComponent is only invoked when route matches   */
  getComponents(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure(
      [],
      require => {
        /*  Webpack - use require callback to define
          dependencies for bundling   */
        const ProductList = require("./containers/ProductsContainer").default;
        const CategoryList = require("../../containers/Category/CategoriesContainer")
          .default;
        const reducer = require("../../store/product").default;
        // const CartReducer = require('../../store/cart')

        /*  Add the reducer to the store on key 'counter'  */
        injectReducer(store, { key: "product", reducer });
        // injectReducer(store, { key: 'cart', CartReducer })

        /*  Return getComponent   */
        cb(null, { category: CategoryList, main: ProductList });

        /* Webpack named bundle   */
      },
      "productList"
    );
  }
});



// WEBPACK FOOTER //
// ./src/routes/ProductsList/index.js